import { getXsrfToken } from '../api/getXsrfToken';
export const getXsrf = () => {
    return getXsrfToken();
};
